import { makeStyles } from '@material-ui/styles';
import { Theme, Text } from '@bizzabo/design-system';

const ChatMessageDialogTitle = ({ children }) => {
    const classes = useStyles();
    return (
        <Text variant="t50" className={classes.title}>
            {children}
        </Text>
    );
};

const useStyles = makeStyles<Theme>(
    theme => ({
        title: {
            'text-align': 'center',
            color: theme.palette.greys['700'],
            paddingTop: 20,
            paddingBottom: 16,
        },
    }),
    { classNamePrefix: 'ChatMessageDialogTitle' }
);

export default ChatMessageDialogTitle;
